/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "customFields": {
    "API_BASE": "",
    "HCAPTCHA_SITEKEY": "5b421a58-8496-4c78-8c30-833005e84292",
    "DASHBOARD_URL": "https://dashboard.overblock.io",
    "SANDBOX_URL": "https://dashboard.overblock.link"
  },
  "title": "OverBlock.io",
  "tagline": "Managed blockchain data apps. No nodes, no indexer ops.",
  "favicon": "/img/favicon.ico",
  "url": "https://overblock.io",
  "baseUrl": "/",
  "organizationName": "OverBlock",
  "projectName": "overblock",
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "warn",
  "trailingSlash": true,
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en",
      "ua"
    ],
    "localeConfigs": {
      "en": {
        "label": "English",
        "direction": "ltr",
        "htmlLang": "en-US",
        "calendar": "gregory"
      },
      "ua": {
        "label": "Українська",
        "direction": "ltr",
        "htmlLang": "uk-UA",
        "calendar": "gregory",
        "path": "ua"
      }
    },
    "path": "i18n"
  },
  "headTags": [
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "32x32",
        "href": "/img/favicon-32x32.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "16x16",
        "href": "/img/favicon-16x16.png"
      }
    },
    {
      "tagName": "noscript",
      "attributes": {},
      "innerHTML": "\n        <img height=\"1\" width=\"1\" style=\"display:none\"\n          src=\"https://www.facebook.com/tr?id=691036913675221&ev=PageView&noscript=1\"/>\n      "
    }
  ],
  "scripts": [
    {
      "src": "https://connect.facebook.net/en_US/fbevents.js",
      "async": true,
      "defer": true
    },
    {
      "src": "/js/fb-pixel-init.js",
      "head": true
    }
  ],
  "presets": [
    [
      "@docusaurus/preset-classic",
      {
        "docs": {
          "path": "docs",
          "routeBasePath": "docs",
          "sidebarPath": "./sidebars.ts",
          "sidebarCollapsible": true
        },
        "blog": {
          "path": "blog",
          "showReadingTime": true,
          "blogSidebarCount": "ALL",
          "blogSidebarTitle": "All posts",
          "postsPerPage": "ALL",
          "feedOptions": {
            "type": null
          }
        },
        "theme": {
          "customCss": [
            "/vercel/path0/src/css/custom.css"
          ]
        },
        "sitemap": {
          "changefreq": "weekly",
          "priority": 0.5,
          "ignorePatterns": [
            "/tags/**"
          ]
        },
        "gtag": {
          "trackingID": "G-50C9LPQ5RE",
          "anonymizeIP": true
        }
      }
    ]
  ],
  "future": {
    "experimental_faster": {
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "rspackBundler": true,
      "mdxCrossCompilerCache": true
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "themeConfig": {
    "docs": {
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      },
      "versionPersistence": "localStorage"
    },
    "navbar": {
      "hideOnScroll": true,
      "title": "",
      "logo": {
        "src": "img/logo-light.svg",
        "srcDark": "img/logo-dark.svg",
        "alt": "OverBlock.io logo"
      },
      "items": [
        {
          "to": "/apps",
          "label": "Apps",
          "position": "left"
        },
        {
          "to": "/pricing",
          "label": "Pricing",
          "position": "left"
        },
        {
          "to": "/sandbox",
          "label": "Sandbox",
          "position": "left"
        },
        {
          "to": "/blog",
          "label": "Blog",
          "position": "left"
        },
        {
          "to": "/#newsletter",
          "label": "Join our Newsletter",
          "position": "left",
          "className": "navbar-newsletter-cta",
          "icon": "mail"
        },
        {
          "type": "docSidebar",
          "sidebarId": "docs",
          "to": "/docs",
          "position": "right",
          "label": "Docs",
          "icon": "book"
        },
        {
          "href": "https://dashboard.overblock.io",
          "label": "Dashboard",
          "position": "right",
          "className": "navbar-dashboard-cta",
          "icon": "login"
        },
        {
          "type": "custom-smartLocaleDropdown",
          "position": "right"
        }
      ]
    },
    "footer": {
      "links": [
        {
          "title": "Products",
          "items": [
            {
              "label": "Apps Catalog",
              "to": "/apps"
            },
            {
              "label": "stream-app",
              "to": "/docs/apps/stream-app"
            },
            {
              "label": "bitcoin-fees-advisor",
              "to": "/docs/apps/bitcoin-fees-advisor"
            },
            {
              "label": "evm-fees-advisor",
              "to": "/docs/apps/evm-fees-advisor"
            }
          ]
        },
        {
          "title": "Resources",
          "items": [
            {
              "label": "Docs",
              "to": "/docs"
            },
            {
              "label": "Blog",
              "to": "/blog"
            },
            {
              "label": "Pricing",
              "to": "/pricing"
            },
            {
              "label": "Sandbox",
              "to": "/sandbox"
            }
          ]
        },
        {
          "title": "Company",
          "items": [
            {
              "label": "Privacy Policy",
              "to": "/policy"
            },
            {
              "label": "Terms & Conditions",
              "to": "/terms"
            },
            {
              "label": "Security Policy",
              "to": "/security"
            }
          ]
        }
      ],
      "style": "light"
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": true
    },
    "prism": {
      "defaultLanguage": "typescript",
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [
        "docker",
        "log",
        "bash",
        "diff",
        "json"
      ],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "image": "img/overblock-social-default.png",
    "metadata": [
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },
      {
        "name": "twitter:site",
        "content": "@overblock_io"
      },
      {
        "name": "twitter:creator",
        "content": "@overblock_io"
      },
      {
        "name": "twitter:title",
        "content": "OverBlock.io"
      },
      {
        "name": "twitter:description",
        "content": "OverBlock provides managed blockchain data apps: Bitcoin block streaming, fee estimation, and EVM gas APIs. No nodes, no indexer ops."
      },
      {
        "name": "twitter:image",
        "content": "https://overblock.io/img/overblock-social-default.png"
      },
      {
        "name": "description",
        "content": "OverBlock provides managed blockchain data apps: Bitcoin block streaming, fee estimation, and EVM gas APIs. No nodes, no indexer ops."
      },
      {
        "name": "keywords",
        "content": "crypto, blockchain, bitcoin, ethereum, data indexing, self hosted, tools"
      },
      {
        "name": "author",
        "content": "OverBlock Team"
      },
      {
        "name": "robots",
        "content": "index, follow"
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "property": "og:title",
        "content": "OverBlock.io"
      },
      {
        "property": "og:description",
        "content": "OverBlock provides managed blockchain data apps: Bitcoin block streaming, fee estimation, and EVM gas APIs. No nodes, no indexer ops."
      },
      {
        "property": "og:image",
        "content": "https://overblock.io/img/overblock-social-default.png"
      },
      {
        "property": "og:url",
        "content": "https://overblock.io"
      },
      {
        "property": "og:site_name",
        "content": "OverBlock.io"
      }
    ],
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "plugins": [
    null,
    null,
    [
      null,
      {
        "siteBaseUrl": "/",
        "blogRouteBasePath": "blog",
        "docsRouteBasePath": "docs"
      }
    ]
  ],
  "baseUrlIssueBanner": true,
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "themes": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  }
};
